import { useEffect } from "react";
import { Link } from "react-router-dom";

const promises = [
  {
    icon: "ri-shield-check-line",
    title: "内容清晰可靠",
    desc: "精选影视内容与资讯，信息真实完整，为你提供可靠的浏览参考。",
  },
  {
    icon: "ri-speed-up-line",
    title: "浏览便捷流畅",
    desc: "清晰的分类、实时的筛选与便捷的搜索，帮助快速定位想看的内容。",
  },
  {
    icon: "ri-heart-3-line",
    title: "尊重用户体验",
    desc: "界面简洁舒适，适配各类设备，让浏览过程轻松无负担。",
  },
  {
    icon: "ri-leaf-line",
    title: "坚持内容推荐",
    desc: "专注影视推荐与信息服务，不提供真实播放与下载，营造健康环境。",
  },
];

const stats = [
  { value: "24+", label: "精选影视作品" },
  { value: "3", label: "核心影视分类" },
  { value: "8", label: "覆盖地区" },
  { value: "100%", label: "内容浏览免费" },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = "关于我们 - 青青草视频";
    return () => {
      document.title = "青青草视频—高清影视资源在线观看与最新影视推荐";
    };
  }, []);

  return (
    <div className="w-full">
      <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20background%20of%20flowing%20green%20silk%20waves%20blending%20into%20warm%20amber%20light%2C%20soft%20cinematic%20gradient%2C%20elegant%20minimal%20composition%2C%20deep%20dark%20tones%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=about-hero&orientation=landscape"
          alt="关于青青草视频"
          title="关于青青草视频"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-background-50/40" />
        <div className="absolute inset-0 flex items-center">
          <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4 flex-wrap">
              <Link to="/" className="hover:text-primary-300 transition-colors cursor-pointer">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-900">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950">
              关于青青草视频
            </h1>
            <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-700 leading-relaxed">
              一个专注高清影视资源浏览与最新影视推荐的综合信息平台，让每一次内容发现都更轻松。
            </p>
          </div>
        </div>
      </section>

      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8 py-12 md:py-16 space-y-14">
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/15 text-primary-300 text-xs font-semibold mb-4">
              <i className="ri-leaf-fill" />
              平台定位
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              为影视爱好者打造的内容发现平台
            </h2>
            <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                青青草视频致力于为电影、电视剧、综艺爱好者提供丰富的影视内容浏览与最新影视推荐服务。我们汇聚多元类型的影视作品，通过清晰的分类体系与多维筛选，帮助你在海量内容中快速找到感兴趣的作品。
              </p>
              <p>
                无论是追剧、找片还是发现冷门佳作，你都可以在这里获得结构化、易浏览的影视信息。平台持续更新内容，让最新影视动态与热门作品触手可及。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索内容
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/70 text-foreground-900 text-sm font-semibold hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-background-100 border border-background-200/70 p-6 text-center"
              >
                <p className="font-heading text-3xl md:text-4xl font-extrabold text-primary-400">
                  {stat.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <section>
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              我们的服务承诺
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              以用户为中心，持续提供优质的内容浏览体验
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {promises.map((item) => (
              <div
                key={item.title}
                className="rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-primary-500/40 transition-colors"
              >
                <span className="w-12 h-12 rounded-lg bg-accent-500/15 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-2xl text-accent-400`} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="rounded-lg overflow-hidden border border-background-200/70 bg-gradient-to-r from-primary-950/80 to-background-100 p-8 md:p-12 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            与我们一起发现好内容
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-700 leading-relaxed">
            探索电影、电视剧与综艺的精彩世界，收藏你喜欢的作品，随时回来查看最新推荐。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/category/variety"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览综艺频道
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-200/70 text-foreground-900 text-sm font-semibold hover:bg-background-300/70 transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索影视内容
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}